export function splitToSubCollections(array: any[], size: number) {
  const chunked_arr = [];
  let index = 0;
  while (index < array.length) {
    chunked_arr.push(array.slice(index, size + index));
    index += size;
  }
  return chunked_arr;
}

export function arrayItemMove(array: any[], fromIndex: number, toIndex: number) {
  var element = array[fromIndex];
  array.splice(fromIndex, 1);
  array.splice(toIndex, 0, element);
}

export function arrayItemMoveFirst(array: any[], fromIndex: number) {
  var element = array[fromIndex];
  array.splice(fromIndex, 1);
  array.unshift(element);
}
